import { render, staticRenderFns } from "./HeatmapChart.vue?vue&type=template&id=b39dc6fe&scoped=true"
import script from "./HeatmapChart.vue?vue&type=script&lang=js"
export * from "./HeatmapChart.vue?vue&type=script&lang=js"
import style0 from "./HeatmapChart.vue?vue&type=style&index=0&id=b39dc6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39dc6fe",
  null
  
)

export default component.exports